export default (...classes: (string | undefined | false)[]) => classes.filter(Boolean).join(' ');
